export const seo_meta = {
    home: {
        title: 'Rud Runner | Toko Sepatu Lari Original di Jakarta, Bandung & Bali',
        description:
            'Rud Runner adalah toko sepatu lari original dan perlengkapan lari dari Nike, Adidas, Asics, Puma, Saucony, On Cloud dan lainnya. 100% Original. Potongan spesial 10% di website.'
    },
    product_list: {
        title: 'Product List | Rud Runner',
        description:
            'Rud Runner, toko sepatu dan perlengkapan running terlengkap di indonesia. Temukan berbagai pilihan sepatu, aksesori, dan berbagai produk dari brand ternama lainnya. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    men_footwear: {
        title: 'Jual Sepatu Running Pria Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi sepatu running pria original terlengkap di Rud Runner. Temukan berbagai pilihan footwear, mulai Adidas, Asics, Brooks, Hoka, New Balance, Nike, On Cloud, Puma, Saucony, dan brand ternama lainnya. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    men_apparel: {
        title: 'Jual Apparel Running Pria Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi apparel running pria original terlengkap di Rud Runner. Temukan berbagai pilihan apparel running keren & berkualitas dari brand-brand ternama. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    men_short_pants: {
        title: 'Jual Celana Running Pria Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi celana running pria original terlengkap di Rud Runner. Temukan berbagai pilihan celana pendek running keren & berkualitas dari brand-brand ternama. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    men_slide: {
        title: 'Jual slide pria Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi sandal slide pria original terlengkap di Rud Runner. Pilihan sandal slop nyaman dari brand-brand ternama untuk gaya kasual Anda. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    men_trail: {
        title: 'Jual Sepatu Trail Running Pria Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi sepatu Trail running pria original terlengkap di Rud Runner. Temukan berbagai pilihan footwear, mulai Adidas, Asics, Brooks, Hoka, New Balance, Nike, On Cloud, Puma, Saucony, dan brand ternama lainnya. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    women_footwear: {
        title: 'Jual Sepatu Running Wanita Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi sepatu running Wanita original terlengkap di Rud Runner. Temukan berbagai pilihan footwear, mulai Adidas, Asics, Brooks, Hoka, New Balance, Nike, On Cloud, Puma, Saucony, dan brand ternama lainnya. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    women_apparel: {
        title: 'Jual Apparel Running Wanita Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi apparel running Wanita original terlengkap di Rud Runner. Temukan berbagai pilihan apparel running keren & berkualitas dari brand-brand ternama. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    women_short_pants: {
        title: 'Jual Celana Running Wanita Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi celana running Wanita original terlengkap di Rud Runner. Temukan berbagai pilihan celana pendek running keren & berkualitas dari brand-brand ternama. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    women_slide: {
        title: 'Jual slide Wanita Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi sandal slide Wanita original terlengkap di Rud Runner. Pilihan sandal slop nyaman dari brand-brand ternama untuk gaya kasual Anda. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    women_trail: {
        title: 'Jual Sepatu Trail Running Wanita Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi sepatu Trail running Wanita original terlengkap di Rud Runner. Temukan berbagai pilihan footwear, mulai Adidas, Asics, Brooks, Hoka, New Balance, Nike, On Cloud, Puma, Saucony, dan brand ternama lainnya. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    hat: {
        title: 'Jual Berbagai Topi Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi berbagai topi original di Rud Runner. Desain sporty, nyaman dipakai, cocok untuk gaya kasual dan olahraga. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    socks: {
        title: 'Jual Berbagai Kaos Kaki Terbaru, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Kaos kaki running original di Rud Runner. Nyaman, menyerap keringat, dan mendukung performa saat running. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    bag: {
        title: 'Jual Tas olahraga, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Temukan tas running original di Rud Runner. Desain sporty, kuat, dan praktis untuk latihan maupun harian. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    backpack: {
        title: 'Jual Tas olahraga & Backpack, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Temukan tas running dan backpack original di Rud Runner. Desain sporty, kuat, dan praktis untuk latihan maupun harian. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    duffle: {
        title: 'Jual duffle bag, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Temukan duffle bag original di Rud Runner. Desain sporty, kuat, dan praktis untuk latihan maupun harian. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    others: {
        title: 'Jual Berbagai Aksesories Running Terlengkap, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Temukan berbagai aksesories running terlengkap & original di Rud Runner. Untuk mendukung latihan maupun aktifitas harian lainnya. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    tumbler: {
        title: 'Jual Berbagai Tumbler, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi berbagai tumbler di Rud Runner yang stylish, cocok untuk gaya kasual dan olahraga. Produk 100% original! Gratis ongkir se-Indonesia.'
    },
    bottle: {
        title: 'Jual Berbagai Botol Minum, 100% Original & Gratis ongkir se-Indonesia | Rud Runner',
        description:
            'Koleksi berbagai botol minum di Rud Runner yang stylish, cocok untuk gaya kasual dan olahraga. Produk 100% original! Gratis ongkir se-Indonesia.'
    }
}